import {InlineGroupSelect} from '@shipwell/shipwell-ui';
import {FormGroup} from 'react-bootstrap';

type OptionsType = {
  label: string;
  options:
    | {
        label: string;
        value: string;
      }[]
    | undefined;
}[];

export const InlineGroupDropDownSelector = ({
  options,
  input,
  changeField,
  index,
  meta: {touched, error}
}: {
  options: OptionsType;
  input: {onChange: (value: string) => void; name: string};
  changeField: (form: string, field: string, value: string) => void;
  index: number;
  meta: {touched: boolean; error: string};
}) => {
  return (
    <FormGroup controlId={input.name} validationState={touched && error ? 'error' : null}>
      <div className="max-h-[36px] rounded-md">
        <InlineGroupSelect
          className=""
          placeholder="Type to Search"
          options={options}
          clearable={false}
          onChange={(event: {label: string; value: string; category: string; chargeCode: string}) => {
            changeField('shipmentFinancialsForm', `financials['${index}'].unit_name`, event?.label);
            changeField('shipmentFinancialsForm', `financials['${index}'].charge_code`, event?.chargeCode);
            input.onChange(event?.category);
          }}
        />
      </div>
      {touched && error && (
        <p className="error-text">
          <i className="icon icon-Delayed" />
          {error}
        </p>
      )}
    </FormGroup>
  );
};
